import DirectionsBoatFilledRounded from '@mui/icons-material/DirectionsBoatFilledRounded';
import History from '@mui/icons-material/History';
import Timeline from '@mui/icons-material/Timeline';
import OperationalView from '@/assets/svg/operational.svg?react';
import SimulationView from '@/assets/svg/simulation.svg?react';
import { MenuItemGroupProps } from '@/components/common/Menu/types';
import { LicenseFeatures } from '@/types';
import { useBackToMapFromOperationalCallback, useBackToMapFromSimulationCallback } from './hooks/useBackToMapCallback';

export const defaultMenuGroups: MenuItemGroupProps[] = [
  {
    title: 'Safety assesment',
    showTitle: true,
    showDividerAfter: true,
    icon: <Timeline />,
    items: [
      {
        displayText: 'Operational',
        description: 'Safety overview displaying a list of potential unsafe berths, moored vessels etc.',
        icon: <OperationalView width={32} />,
        linkTo: '/safety-prediction/operational',
        licenceFeature: LicenseFeatures.AIS_DETECTION,
        featureFlag: 'OPERATIONAL_VIEW',
      },
      {
        displayText: 'Simulation',
        description: 'Safety prediction overview of the port using a map of the port displaying the status of all berths',
        icon: <SimulationView width={32} />,
        linkTo: '/safety-prediction/simulation',
      },
      {
        displayText: 'Vessel clearance',
        description: 'Static safety analysis based on industry standards',
        icon: <DirectionsBoatFilledRounded sx={{ fontSize: 32 }} width={32} />,
        licenceFeature: LicenseFeatures.VESSEL_CLEARANCE,
        linkTo: '/vessel-clearance',
      },
      {
        displayText: 'Assessment history',
        description: 'View history of assessments',
        disabled: false,
        icon: <History sx={{ fontSize: 32 }} />,
        linkTo: '/safety-prediction/historical',
        licenceFeature: LicenseFeatures.HISTORIC_OVERVIEW,
        featureFlag: 'HISTORICAL_VIEW',
      },
    ],
  },
];

export function useDefaultMenuGroups(): MenuItemGroupProps[] {
  const simulationCallback = useBackToMapFromSimulationCallback();
  const operationalCallback = useBackToMapFromOperationalCallback();

  return [
    {
      title: 'Safety assessment',
      showTitle: true,
      showDividerAfter: true,
      icon: <Timeline />,
      items: [
        {
          displayText: 'Operational',
          description: 'Safety overview displaying a list of potential unsafe berths, moored vessels etc.',
          icon: <OperationalView width={32} />,
          licenceFeature: LicenseFeatures.AIS_DETECTION,
          featureFlag: 'OPERATIONAL_VIEW',
          onClick: operationalCallback,
        },
        {
          displayText: 'Simulation',
          description: 'Safety prediction overview of the port using a map of the port displaying the status of all berths',
          icon: <SimulationView width={32} />,
          onClick: simulationCallback,
        },
        {
          displayText: 'Vessel clearance',
          description: 'Static safety analysis based on industry standards',
          icon: <DirectionsBoatFilledRounded sx={{ fontSize: 32 }} width={32} />,
          licenceFeature: LicenseFeatures.VESSEL_CLEARANCE,
          linkTo: '/vessel-clearance',
        },
        {
          displayText: 'Assessment history',
          description: 'View history of assessments',
          disabled: false,
          icon: <History sx={{ fontSize: 32 }} />,
          linkTo: '/safety-prediction/historical',
          licenceFeature: LicenseFeatures.HISTORIC_OVERVIEW,
          featureFlag: 'HISTORICAL_VIEW',
        },
      ],
    },
  ];
}
